module.exports = __webpack_public_path__ + "static/media/mascaraCilios2.7335f0d5.jpg";